import {Injectable, Injector} from "@angular/core";
import {CleverreportStoreState} from "../cleverreport.store.module";
import {Store} from "@ngrx/store";
import {DataProvider} from "../../providers/dataprovider/dataprovider";
import {SettingEntity} from "./setting.entity";
import {SettingActions} from "./setting.actions";
import {Observable} from "rxjs/Observable";

@Injectable()
export class SettingService {

  private databaseProvider;
  constructor(private store: Store<CleverreportStoreState>, private injector: Injector){
    setTimeout(() => {
      this.databaseProvider = injector.get(DataProvider);
    })
  }

  add(setting: SettingEntity, synced: boolean = true): void {
    if(!synced){
      this.databaseProvider.createDocumentWithoutInit(setting)
        .then((setting: SettingEntity) => {
          this.store.dispatch(SettingActions.add(setting));
        })
    } else {
      this.store.dispatch(SettingActions.add(setting));
    }
  }

  set(setting: SettingEntity, synced: boolean = true): void {
    if(!synced){
      this.databaseProvider.updateDocument(setting)
        .then((setting: SettingEntity) => {
          this.store.dispatch(SettingActions.set(setting));
        })
    } else {
      this.store.dispatch(SettingActions.set(setting));
    }
  }

  get(): Observable<SettingEntity> {
    return this.store.select('setting');
  }
}



// WEBPACK FOOTER //
// ./src/store/setting/setting.service.ts